export interface IRecorderStream {
  sid: string;
  type: RecorderStreamType;
  isPano: boolean;
  deviceId: string;
  cutout: string;
  status: RecorderStatus;
  started: number;
  hasStarted: boolean;
  /** Wanneer de lopende opname vanzelf stopt (ms sinds 1970); 0/leeg = onbekend. */
  plannedEnd?: number;
  automaticRecording: boolean;
  pitch: string;
  hasPitch: boolean;
  /** De velden waar deze camera op staat; een camera kan er op meer dan één
   *  uitkijken. Leeg = nog niet ingedeeld. */
  pitches: string[];
  /** Staat deze camera aan in de studio? Ontbreekt = aan (oudere recorder). */
  enabled?: boolean;
  /** De naam die de club op het platform heeft gekozen. Leeg = toon `cutout`,
   *  de naam die de recorder zelf meestuurt. */
  label?: string;
  /** De plek in de lijst; laag staat boven, 0 = nooit gezet. */
  order?: number;
  /** Hoeken van een panoramacamera (bol) als JSON, van de studio. Leeg bij
   *  een gewone camera. */
  panoSettings?: string;
  /**
   * Stand van het stuurkruis, gemeld door de studio: `auto` (de camera volgt
   * zelf een groep spelers en laat zich niet sturen) of `manual`. Leeg = deze
   * camera kent geen A/M-stand; dan is er geen A/M-knop (02-10-2026).
   */
  ptzMode?: 'auto' | 'manual' | '';
  /**
   * Alleen opnemen: van deze camera worden geen clips gemaakt, voor geen enkele
   * tag of event (eigenaar 09-10-2026). Ontbreekt of false = clips, zoals
   * altijd. Wordt gezet in de beheerconsole; zie helpers/live-clips.ts.
   */
  recordOnly?: boolean;
  /**
   * Heeft deze camera een bestuurbare kop (pan/tilt/zoom)? Nog niet gemeld:
   * de streamregistratie van de studio (platform_streams.rs, RegisterStream)
   * stuurt alleen `cameraType` (Onvif/Virtual/Manual) mee. Zodra hij dit
   * meldt, geldt het; tot dan de gok van RecorderComponent.heeftPtz, zoals
   * het was (live-ontwerp 31-10-2026).
   */
  ptz?: boolean;
  /**
   * De presets van de camera zelf (ONVIF), op naam. Nog niet gemeld; komt
   * met dezelfde streamregistratie, samen met een opdracht om erheen te gaan
   * (platform_opdracht.rs). Tot dan staat de knop Presets er niet.
   */
  presets?: string[];
  cameraType: string;
  hasCameraType: boolean;
  url: string;
  protocol: RecorderStreamProtocol;
  activeRecording?: string;
  selected?: boolean;
  waitingForScreenshot?: boolean;
  /** Naam om in de camera-kiezer te tonen: `label` als de club die gezet
   *  heeft, anders `cutout` (de naam die de recorder zelf meestuurt). */
  displayName?: string;
  /** Tijdelijke, per-camera WHEP-kijk-URL - opgehaald via /Live/ViewToken,
   *  want `url` zelf is voor een clubgebruiker altijd leeg (zie
   *  RecordersController.BlankStreamUrls). */
  viewUrl?: string;
  /** HLS-adres van dezelfde camera, voor AirPlay en Chromecast (zie
   *  TvUitzendingService). Alleen als de relay HLS aanbiedt. */
  tvUrl?: string;
}

export enum RecorderStreamType {
  UnknownType = 'UnknownType',
  Virtual = 'Virtual',
  Ip = 'Ip'
}

export enum RecorderStatus {
  UnknownStatus = 'UnknownStatus',
  Streaming = 'Streaming',
  Recording = 'Recording',
  Offline = 'Offline',
}

export enum RecorderStreamProtocol {
  UnknownStreamProtocol = 'UnknownStreamProtocol',
  Hls = 'Hls',
  WebRTC = 'Webrtc',
}
